import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function ReverseMomentum() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Reverse the fleshly momentum; reorient your life in the Spirit." />
        <blockquote>
  “As obedient children, do not be conformed to the former lusts which were yours in your ignorance, but like the Holy One who called you, be holy yourselves also in all your behavior; because it is written, “You shall be holy, for I am holy.” (1 Peter 1:14-16)
</blockquote>

<p>There are times, particularly when we are tired, when we are especially vulnerable to temptation. Lust, irritability, anger, laziness, and other sins seem to feed off tiredness or a lack of sleep. In these situations the best remedy is simply to get a good night’s rest. And we should ensure that we are getting sufficient rest on an ongoing basis. There may be other times when we may be in the presence of certain individuals who know how to “push our buttons” so to speak; and because of past habits of responding in an ungodly way, we quickly fall into the old habits of sinful actions or responses. One thing leads to another, perhaps an argument has started, and things proceed from bad to worse. Or perhaps we have sinned in some way and are now tempted to sin even more because of the first sin. It’s like we’ve started the ball rolling downhill, toward sin, and it quickly gets worse and worse. Whatever the situation, we need to reverse the momentum that has been started toward sin. We need to radically change direction and go the opposite way. Whether that involves sleep, or being bold in sharing the gospel, or speaking out against sin, we need to reverse the momentum of sin in our lives and reorient our lives in the Spirit. The final step, then in responding to temptation when it comes is to reverse the momentum that we have allowed to build in sin’s direction. We should read the Bible, get a good rest, and diligently practice the Rebuilding steps to reorient our lives in the Spirit and reverse the fleshly momentum.</p>
<br />

<ul>
  <li>
    <strong>Order your life so that you regularly get good rest, getting to bed early and rising early to meet the Lord.</strong><br />
    <em>Psalm 4:8, 119:147-148, 127:1-2, Proverbs 3:21-24, 8:34</em>
  </li>
  <br />
  <li>
    <strong>Run the race to win. Evaluate your schedule and eliminate unnecessary tasks; maximize your time; reduce entertainment-oriented activities. Turn off the television and make productive use of your time.</strong><br />
    <em>1 Corinthians 9:24-27, Ephesians 5:15-17</em>
  </li>
  <br />
  <li>
    <strong>Reduce fleshly desires by fasting, listening to Biblical teaching, praising God, fellowshipping with other believers, exercising, etc. Devote yourself to the Word of God and prayer.</strong><br />
    <em>Mark 2:20, Acts 6:4, Colossians 3:16, Hebrews 10:24-25</em>
  </li>
  <br />
  <li>
    <strong>Purpose to be holy in all your words, thoughts, and deeds.</strong><br />
    <em>Matthew 5:48, 1 Peter 1:14-16</em>
  </li>
  <br />
  <li>
    <strong>Rebuild your relationship with God; diligently practice the REBUILDING steps.</strong>
  </li>
</ul>
      </div>
    </PageLayout>
  );
};
